import { render, staticRenderFns } from "./tradeBill.vue?vue&type=template&id=1f29ce20&"
import script from "./tradeBill.vue?vue&type=script&lang=js&"
export * from "./tradeBill.vue?vue&type=script&lang=js&"
import style0 from "./tradeBill.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tradeBill.vue"
export default component.exports